export default __webpack_public_path__ + "static/media/may2024-4.c06773c7.jpg";